import React from 'react';
import { useEffect, useState } from 'react';

export default {
  noop: (): void => null,

  usePromise,
};

type State = 'rejected' | 'resolved' | 'inProgress';

function usePromise<T>(promise: Promise<T>): [T, Error, State] {
  const [result, setResult] = useState<T>(null);
  const [state, setState] = useState<State>('inProgress');
  const [error, setError] = useState<Error>(null);

  useEffect(() => {
    promise
      .then(data => {
        setResult(data);
        setState('resolved');
      })
      .catch(error => {
        setError(error);
        setState('rejected');
      });
  }, [promise]);

  return [result, error, state];
}

export const holdPlace = (
  ready = false,
  render: () => React.ReactNode = () => null,
  width = 12
): React.ReactNode => {
  if (ready) {
    return render();
  }
  return (
    <span style={{ backgroundColor: '#ccc', borderRadius: '0.2rem' }}>
      {Array.from({ length: width }).map((_, i) => (
        <React.Fragment key={i}>&#160;</React.Fragment>
      ))}
    </span>
  );
};
